import { render } from "./orderlist.vue?vue&type=template&id=cd5bbc2a"
import script from "./orderlist.vue?vue&type=script&lang=js"
export * from "./orderlist.vue?vue&type=script&lang=js"

import "./orderlist.vue?vue&type=style&index=0&id=cd5bbc2a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__